import { render, staticRenderFns } from "./SelectDash.vue?vue&type=template&id=356c13ac&scoped=true"
import script from "./SelectDash.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectDash.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SelectDash.vue?vue&type=style&index=0&id=356c13ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356c13ac",
  null
  
)

export default component.exports